import React from 'react';
import topicFieldModel from './model/topicFieldModel';
import { SelectBasePrototype } from 'clad';

export const SelectTopicField = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;
    const handleFetch = () => topicFieldModel.listTopicField();

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a topic field')}
            schema={{ idOption: 'id_field', option: 'fieldlet_name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
        />
    );
});
